import { render, staticRenderFns } from "./NbSelectTableColumnsModal.vue?vue&type=template&id=713a6a1f&scoped=true&"
import script from "./NbSelectTableColumnsModal.vue?vue&type=script&lang=js&"
export * from "./NbSelectTableColumnsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a6a1f",
  null
  
)

export default component.exports